import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-white px-2" }
const _hoisted_2 = { class: "flex flex-col gap-[5px] pt-3 mt-3" }
const _hoisted_3 = { class: "flex w-full flex-col" }
const _hoisted_4 = { class: "self-start text-sm" }
const _hoisted_5 = { class: "w-full flex flex-col items-center pb-1 pt-6" }
const _hoisted_6 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_7 = { class: "w-full flex flex-col items-center pb-6" }
const _hoisted_8 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_9 = { class: "flex w-full pt-16" }
const _hoisted_10 = { class: "text-sm text-gray-400" }
const _hoisted_11 = { class: "p-6 flex flex-col justify-center w-full" }
const _hoisted_12 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DbPasswordInput = _resolveComponent("DbPasswordInput")!
  const _component_db_button = _resolveComponent("db-button")!
  const _component_db_form = _resolveComponent("db-form")!
  const _component_AppModal = _resolveComponent("AppModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_db_form, { class: "flex flex-col gap-[5px]" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("landing.reset_password.set_new_password")), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_DbPasswordInput, {
                modelValue: _ctx.user.password,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.password) = $event)),
                placeholder: _ctx.$t('account.password') + '*',
                label: _ctx.$t('landing.password') + '*',
                variant: "white",
                name: "password",
                class: _normalizeClass({
              'border-red-500':
                !_ctx.isFieldValid('password', _ctx.user) && _ctx.form.processing,
            }),
                ariainvalid: 
              !_ctx.isFieldValid('password', _ctx.user) && _ctx.form.processing ? 'true' : ''
            
              }, null, 8, ["modelValue", "placeholder", "label", "class", "ariainvalid"]),
              (!_ctx.isFieldValid('password', _ctx.user) && _ctx.form.processing)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("account.validation.password")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_DbPasswordInput, {
                modelValue: _ctx.user.password_confirmation,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.password_confirmation) = $event)),
                placeholder: _ctx.$t('account.password_confirmation') + '*',
                label: _ctx.$t('account.password_confirmation') + '*',
                variant: "white",
                name: "password_confirmation",
                class: _normalizeClass({
              'border-red-500':
                !_ctx.isFieldValid('password_confirmation', _ctx.user) && _ctx.form.processing,
            }),
                ariainvalid: 
              !_ctx.isFieldValid('password_confirmation', _ctx.user) && _ctx.form.processing
                ? 'true'
                : ''
            
              }, null, 8, ["modelValue", "placeholder", "label", "class", "ariainvalid"]),
              (
              !_ctx.isFieldValid('password_confirmation', _ctx.user) && _ctx.form.processing
            )
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("account.validation.password_confirmation")), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_db_button, {
              id: "login",
              variant: "brand-primary",
              "class-list": "w-full mt-2",
              onClick: _ctx.reset
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("landing.reset_password.confirm")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("landing.required_field")), 1)
        ])
      ])
    ]),
    _createVNode(_component_AppModal, {
      id: "reset-password-modal",
      visible: _ctx.form.successful,
      "modal-size": "md",
      modalType: "accept",
      cancelText: "landing.reset_password.to_login",
      onHideModal: _ctx.close
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _cache[2] || (_cache[2] = _createElementVNode("h2", null, "********", -1)),
          _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.$t("landing.reset_password.password_changed")), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible", "onHideModal"])
  ], 64))
}